import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const NavbarLogoLink = styled(Link)`
  img {
    height: 100%;
  }

  .navbar-secret {
    display: none;
  }

  &:hover {
    cursor: pointer;
    .navbar-logo {
      display: none;
    }
    .navbar-secret {
      display: inline-block;
    }
  }
`;
